import { DollarCircleOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Col, Divider, Row, Select, Space, Table, Tooltip, Tour, Typography, Alert, Modal, message } from "antd"
import { collection, onSnapshot, query, where, writeBatch, deleteDoc, doc, getDocs, updateDoc } from "firebase/firestore"
import React, { useEffect, useRef, useState } from "react"
import { db } from "../../../firebase/config"
import { useCollection } from "../../../hooks/useCollection"
import moment from "moment"
import useInteractiveTableFilters from "../../../components/Filters/InteractiveFilters"
import ShowSavedPricesDrawer from "../../../components/Manager/Prices/ShowSavedPricesDrawer"
import PriceDisplay from "../../../components/utils/PriceDisplay"
import PriceRequestSidebar from "../../../components/Admin/PriceRequest/PriceRequestSidebar"
import OrderHistory from "../../../components/Manager/Prices/OrderHistory"
import { loadingSpin } from "../../../components/Elements/LoadingSpinner"
import { useAuthContext } from "../../../hooks/useAuthContext"
import DuplicateTransferModal from "../../../components/Admin/Prices/DuplicateTransferModal"

const { Option } = Select
const { Title, Text, Link } = Typography

//initial users data
const initalUsers = []

export default function AllPrices() {
  const { semiAdmin, admin } = useAuthContext()
  //gets users data from useCollection hook
  const { data: usersData, loading: usersLoading } = useCollection("users", [
    "group",
    "array-contains",
    "sales",
  ])

  const filterConfig = [
    { key: "client", dataIndex: "client" },
    { key: "userEmail", dataIndex: "userEmail" },
    { key: "product", dataIndex: ["product", "productName"] },
  ]

  // all users
  const [users, setUsers] = useState(initalUsers)
  const [seletectedUser, setSelectedUser] = useState("allUsers")

  // Set default selected manager to "allUsers"
  const [selectedManger, setSelectedManger] = useState("allUsers")

  //user Price table data
  const [priceTableData, setPriceTableData] = useState(null)
  const [tableLoading, setTableLoading] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [transferLoading, setTransferLoading] = useState(false)
  const [selectedTransferUser, setSelectedTransferUser] = useState(null)
  const [salesUsers, setSalesUsers] = useState([])

  const [open, setOpen] = useState(false)

  //price tour data
  const [openPriceTour, setOpenPriceTour] = useState(false)
  //refs for price tour
  const selectClientRef = useRef(null)
  const selectManagerRef = useRef(null)
  const viewFileRef = useRef(null)
  const viewDetailsRef = useRef(null)

  const [appliedFilters, setAppliedFilters, generateFilters] = useInteractiveTableFilters(
    priceTableData,
    filterConfig
  )

  // steps for price tour
  //steps for tour
  const materialTourSteps = [
    {
      title: "Manager Box",
      description: "You can select and the dropdown will open.",
      placement: "right",
      target: () => selectClientRef.current,
    },
    {
      title: "Select Manager",
      description: "Here you can select desired manager. We will pick jekaterina@pprintgroup.com",
      placement: "right",
      target: () => selectClientRef.current,
    },
    {
      title: "Price Table",
      description:
        "Now that a manager is selected you can view all the prices that this manager owns.",
      placement: "top",
      target: () => selectManagerRef.current,
    },
    {
      title: "View file",
      description: "You can view file by clicking the link",
      placement: "bottom",
      target: () => viewFileRef.current,
    },
    {
      title: "View details",
      description: "You can view details of the price by pressing View",
      placement: "bottom",
      target: () => viewDetailsRef.current,
    },
  ]

  //steps for tour
  const handleStepChange = (current) => {
    if (current === 1) {
      setOpen(true)
    } else if (current === 2) {
      setOpen(false)
      handleSelectUser("WpgIzBJFWAZWOpx6idsutGXqbd02", "jekaterina@pprintgroup.com")
    }
  }

  //opens hides select
  const handleClick = () => {
    setOpen(!open)
  }

  //tour closed function
  const closeTour = () => {
    handleSelectUser("", "")
    setOpenPriceTour(false)
  }

  //loads table data based on selected user
  useEffect(() => {
    setTableLoading(true)

    let priceRef = query(collection(db, "priceCalculation"), where("user", "==", seletectedUser))
    if (seletectedUser === "allUsers") {
      priceRef = query(collection(db, "priceCalculation"))
    }

    const unsubscribe = onSnapshot(priceRef, (snapshot) => {
      let results = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))

      // ✅ Apply role-based filtering
      if (!admin) {
        results = results.filter((item) => item.user !== "E1XNaWvT6PccXRSKB3JNlNehI362")
      }

      setPriceTableData(results)
      setTableLoading(false)
    })

    return () => unsubscribe()
  }, [seletectedUser, admin])

  //sets state of users from user data
  useEffect(() => {
    setUsers(usersData)
    console.log(usersData)
  }, [usersData])

  //fetch sales users for transfer
  useEffect(() => {
    const usersQuery = query(collection(db, "users"), where("group", "array-contains", "sales"))
    const unsubscribe = onSnapshot(usersQuery, (snapshot) => {
      const users = []
      snapshot.docs.forEach((doc) => {
        users.push({ ...doc.data(), id: doc.id })
      })
      setSalesUsers(users)
    })
    return () => unsubscribe()
  }, [])

  //handles user select
  const handleSelectUser = (value, label) => {
    setSelectedUser(value)
    setSelectedManger(label)
  }

  const handleTransferPrices = () => {
    setTransferModalOpen(true)
  }

  const handleTransferConfirm = async () => {
    if (!selectedTransferUser) {
      message.error("Please select a sales user")
      return
    }

    setTransferLoading(true)
    try {
      const targetUser = salesUsers.find((u) => u.id === selectedTransferUser)
      let batch = writeBatch(db)
      let batchCount = 0

      for (const priceId of selectedRowKeys) {
        batch.update(doc(db, "priceCalculation", priceId), {
          user: selectedTransferUser,
          userEmail: targetUser.email,
        })
        batchCount++

        if (batchCount === 500) {
          await batch.commit()
          batch = writeBatch(db)
          batchCount = 0
        }
      }

      if (batchCount > 0) await batch.commit()

      message.success(
        `Transferred ${selectedRowKeys.length} price(s) to ${targetUser.email}`,
      )
      setSelectedRowKeys([])
      setSelectedTransferUser(null)
      setTransferModalOpen(false)
    } catch (error) {
      console.error("Error transferring prices:", error)
      message.error("Failed to transfer prices. Check console for details.")
    } finally {
      setTransferLoading(false)
    }
  }

  const handleDeleteSelectedPrices = () => {
    Modal.confirm({
      title: "Delete Prices",
      content: (
        <div>
          <p>
            Are you sure you want to delete <strong>{selectedRowKeys.length}</strong> price(s)?
          </p>
          <p style={{ color: "red", marginBottom: 0 }}>
            <strong>Warning:</strong> This will permanently delete the selected price calculation(s).
            This action cannot be undone.
          </p>
        </div>
      ),
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        setDeleteLoading(true)
        try {
          let batch = writeBatch(db)
          let batchCount = 0

          for (const priceId of selectedRowKeys) {
            batch.delete(doc(db, "priceCalculation", priceId))
            batchCount++

            if (batchCount === 500) {
              await batch.commit()
              batch = writeBatch(db)
              batchCount = 0
            }
          }

          if (batchCount > 0) await batch.commit()

          message.success(`Deleted ${selectedRowKeys.length} price(s)`)
          setSelectedRowKeys([])
        } catch (error) {
          console.error("Error deleting prices:", error)
          message.error("Failed to delete prices. Check console for details.")
        } finally {
          setDeleteLoading(false)
        }
      },
    })
  }

  //Controls the state of columns
  const columns = [
    {
      title: "Users",
      dataIndex: "userEmail",
      filters: generateFilters("userEmail", "userEmail"),
      onFilter: (value, record) => record.userEmail === value,
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Clients",
      dataIndex: "client",
      filters: generateFilters("client", "client"),
      onFilter: (value, record) => record.client === value,
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },

      render: (client) => (
        <Tooltip placement="topLeft" title={client}>
          {client}
        </Tooltip>
      ),
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      ellipsis: {
        showTitle: false,
      },
      filters: generateFilters("product", "productName"),
      filterSearch: true,
      onFilter: (value, record) => record.product.productName === value,
      sorter: (a, b) => {
        const nameA = a.product?.productName || ""
        const nameB = b.product?.productName || ""
        return nameA.localeCompare(nameB)
      },
      render: (productName) => (
        <Tooltip placement="topLeft" title={productName}>
          {productName}
        </Tooltip>
      ),
    },
    {
      title: "Price",
      align: "center",
      dataIndex: "price",
      sorter: (a, b) => a.price - b.price,
      render: (value, record) => {
        return <PriceDisplay data={record} />
      },
    },
    {
      title: "Width",
      dataIndex: "labelWidth",
      align: "center",
      sorter: (a, b) => a.labelWidth - b.labelWidth,
    },
    {
      title: "Height",
      dataIndex: "labelHeight",
      align: "center",
      sorter: (a, b) => a.labelHeight - b.labelHeight,
    },
    {
      title: "Material",
      dataIndex: "material",
      align: "center",
      ellipsis: {
        showTitle: false,
      },
      render: (material) => (
        <Tooltip placement="topLeft" title={material}>
          {material}
        </Tooltip>
      ),
      sorter: (a, b) => a.material.localeCompare(b.material),
    },
    {
      title: "User Image",
      dataIndex: ["product", "productFileUrl"],
      align: "center",
      render: (value, text, index) => (
        <Link
          ref={index === 0 ? viewFileRef : null}
          type="text"
          rel="noreferrer"
          target="_blank"
          href={value}>
          {value ? "Link" : ""}
        </Link>
      ),
    },
    {
      title: "Technical",
      dataIndex: "technicalPage",
      align: "center",
      render: (value, record, index) => {
        if (record.hasTechincalPage === 2) {
          return (
            <Link rel="noreferrer" target="_blank" href={value}>
              Link
            </Link>
          )
        } else {
          return <Text italic>None</Text>
        }
      },
    },
    {
      title: "Changes",
      align: "center",
      render: (text, record) => {
        if (record.adminRequested) {
          return <Link>Progress...</Link>
        } else {
          return <PriceRequestSidebar data={record} />
        }
      },
    },
    {
      title: "Details",
      align: "center",
      render: (value) => (
        <ShowSavedPricesDrawer
          appliedFilters={appliedFilters}
          data={value}
          fromAdmin={semiAdmin || admin}
        />
      ),
    },
    {
      title: "Orders",
      align: "center",
      render: (value) => <OrderHistory price={value} />,
      // render: (rec) => <button onClick={() => console.log(rec)}>log</button>,
    },
    {
      title: "Created",
      dataIndex: ["timestamp", "seconds"],
      sorter: (a, b) => a.timestamp.seconds - b.timestamp.seconds,
      render: (value) => <Text>{moment.unix(value).format("DD.MM.YYYY")}</Text>,
    },
  ]

  if (usersLoading || !usersData || tableLoading || !priceTableData) {
    return loadingSpin(100)
  }

  return (
    <div style={{ padding: "15px", marginBottom: 15 }}>
      <Row justify="space-between" align="middle">
        <Space>
          <Title level={3}>
            <DollarCircleOutlined />
            <Divider type="vertical" /> All Prices{" "}
          </Title>
          <Button onClick={() => setOpenPriceTour(true)} type="text">
            <QuestionCircleOutlined /> Example
          </Button>
        </Space>
        {selectedRowKeys.length > 0 && (
          <Space>
            <Button
              type="primary"
              onClick={() => setDuplicateModalOpen(true)}>
              Duplicate & Transfer ({selectedRowKeys.length})
            </Button>
            <Button
              onClick={handleTransferPrices}
              loading={transferLoading}>
              Transfer Ownership ({selectedRowKeys.length})
            </Button>
            <Button
              danger
              icon={<DeleteOutlined />}
              loading={deleteLoading}
              onClick={handleDeleteSelectedPrices}>
              Delete Selected ({selectedRowKeys.length})
            </Button>
          </Space>
        )}
      </Row>

      <Row gutter={5} align="middle">
        <Col flex="50px">
          <Text>User :</Text>
        </Col>
        <Col ref={selectClientRef}>
          <Select
            style={{ width: 250 }}
            value={selectedManger} // Set the value to selectedManger
            onChange={handleSelectUser}
            loading={usersLoading}
            onClick={handleClick}
            open={open}>
            {users &&
              users.map((res, index) => (
                <Option value={res.id} key={index}>
                  <Text>{res.email}</Text>
                </Option>
              ))}
            <Option value="allUsers">
              <Text>All Users</Text>
            </Option>
          </Select>
        </Col>
      </Row>
      <Tour
        onClose={closeTour}
        open={openPriceTour}
        onChange={handleStepChange}
        steps={materialTourSteps}
      />
      <Divider />
      <Table
        ref={selectManagerRef}
        tableLayout="fixed"
        expandable
        rowKey={(record) => record.id}
        dataSource={priceTableData}
        size="small"
        columns={columns}
        loading={tableLoading}
        pagination={{ defaultPageSize: "25" }}
        rowSelection={{
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys),
        }}
        onChange={(pagination, filters) => {
          setAppliedFilters({
            client: filters.client || [],
            product: filters.product || [],
            userEmail: filters.userEmail || [],
          })
        }}
      />

      <DuplicateTransferModal
        open={duplicateModalOpen}
        onClose={() => {
          setDuplicateModalOpen(false)
          setSelectedRowKeys([])
        }}
        selectedPrices={selectedRowKeys}
        priceData={priceTableData}
      />

      <Modal
        title="Transfer Ownership"
        open={transferModalOpen}
        onCancel={() => {
          setTransferModalOpen(false)
          setSelectedTransferUser(null)
        }}
        onOk={handleTransferConfirm}
        confirmLoading={transferLoading}
        okText="Transfer"
        cancelText="Cancel"
        width={600}>
        <p>
          Transfer <strong>{selectedRowKeys.length}</strong> price(s) to which sales user?
        </p>
        <div style={{ marginBottom: 16 }}>
          <Text strong style={{ display: "block", marginBottom: 8 }}>
            Select Sales User:
          </Text>
          <Select
            placeholder="Choose a sales user..."
            style={{ width: "100%" }}
            value={selectedTransferUser}
            onChange={setSelectedTransferUser}
            options={salesUsers.map((user) => ({
              value: user.id,
              label: user.email,
            }))}
            optionFilterProp="label"
            showSearch
          />
        </div>
      </Modal>
    </div>
  )
}
